module.exports = __webpack_public_path__ + "static/media/arrowUp.65ea400f.svg";